<script lang="ts">
  import {tooltip} from '@/actions/tippy-action';
  import {getInstance} from '@/services/animation';
  import {templateFontStore} from '@/services/animation/font-loader';
  import {onDestroy, onMount} from 'svelte';
  import {writable} from 'svelte/store';
  import {fade, slide} from 'svelte/transition';
  import {SiteCache} from '../../../../cache/Cache';
  import editorInstance from '../../editor';
  import editorStore from '../../editor.store';
  import FontSelector from '../../FontSelector/FontSelector.svelte';
  import {templateFontStore} from '@/services/animation/font-loader';
  import {writable} from 'svelte/store';
  import {onDestroy, onMount} from 'svelte';
  import {tooltip} from '@/actions/tippy-action';
  import {SiteCache} from '../../../../cache/Cache';

  export let targetElement: HTMLElement;
  let styles = writable<any>({});
  let firstLoaded = true;
  let isOpen = false;

  const unsubscribe = editorStore.subscribe(store => {
    if (store.activeComponent) {
      targetElement = store.activeComponent.querySelector('.dynamic') as HTMLElement;
      if (!targetElement) return;
    }
  });

  function loadStyles() {
    if (!targetElement) {
      console.warn('There was no targetElement to load styles on [FontSelect.svelte]');
      return;
    }
    const computedStyle = window.getComputedStyle(targetElement);
    styles.set(computedStyle);
  }

  function recomputeTextSizing() {
    const instance = getInstance();
    if (instance) {
      instance.templateLoader.recomputeTemplateMetadata();
      instance.recomputeCaptionTextSize();
    }
  }

  let selectedFont = targetElement.classList.contains('secondary-font') ? 'Secondary' : 'Primary';

  function changeFontFamily(font: string) {
    const type = font.toLowerCase().replaceAll(' ', '-');
    const index = type == 'primary-font' ? 0 : 1;
    const fontName = $templateFontStore[index];
    if (fontName) {
      const isUserFont = SiteCache.customUserFonts.find((f: any) => f.label === fontName);
      const targetFontFamily = '"' + fontName + '"';
      editorInstance.history.addHistory('font change');
      targetElement.style.fontFamily = targetFontFamily;
      targetElement.style.letterSpacing = 'normal';
      targetElement.classList.remove('primary-font', 'secondary-font');
      targetElement.classList.add(type);
      targetElement.removeAttribute('data-user-fonturl');
      targetElement.removeAttribute('data-user-fontname');
      targetElement.removeAttribute('data-customfontname');
      targetElement.removeAttribute('data-nameoffontfile');
      if (isUserFont) {
        targetElement.setAttribute('data-user-fonturl', isUserFont.url);
        targetElement.setAttribute('data-user-fontname', isUserFont.label);
      }
      loadStyles();
      recomputeTextSizing();
    }
    editorInstance.history.addHistory('Change Font Family');
    isOpen = false;
  }

  const fontOptions = [
    {label: 'Primary', value: 'Primary Font'},
    ...($templateFontStore[1] !== '' ? [{label: 'Secondary', value: 'Secondary Font'}] : [])
  ];

  onMount(() => {
    loadStyles();
  });

  onDestroy(unsubscribe);
</script>

<div class="relative" use:tooltip={'Font'}>
  <button
    class="flex h-full w-max items-center justify-between gap-x-2 rounded-lg border border-gray-300 bg-sermon-base-50 px-3 py-2"
    on:click={() => (isOpen = !isOpen)}
  >
    <span class="text-sm font-bold">{selectedFont}</span>
    <i class="fa-solid fa-chevron-down text-xs transition-transform duration-200" class:rotate-180={isOpen}></i>
  </button>

  {#if isOpen}
    <div class="absolute z-50 mt-1 w-full rounded-lg bg-sermon-base-50 shadow-lg" transition:fade={{duration: 150}}>
      <div class="py-1" transition:slide={{duration: 150}}>
        {#each fontOptions as option}
          <button
            class="w-full px-3 py-1 text-left text-sm font-bold hover:bg-gray-100"
            on:click={() => {
              selectedFont = option.label;
              changeFontFamily(option.value);
            }}
          >
            {option.label}
          </button>
        {/each}
      </div>
    </div>
  {/if}
</div>
